import { render } from "./section2.vue?vue&type=template&id=1831551a&scoped=true"
import script from "./section2.vue?vue&type=script&lang=js"
export * from "./section2.vue?vue&type=script&lang=js"

import "./section2.vue?vue&type=style&index=0&id=1831551a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1831551a"]])

export default __exports__